import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../public/img/logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center bg-[#390261] text-white"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "flex flex-1 items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "p-2 font-medium",
    href: "/dns-course/"
  }, "DNS for Developers — Learn DNS once and for all")
], -1)
const _hoisted_3 = { class: "flex flex-col justify-between items-center shadow-sm bg-white text-gray-800 border-b border-gray-200 sm:flex-row sm:gap-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "NsLookup logo",
  width: "142",
  height: "24",
  class: "inline"
}, null, -1)
const _hoisted_5 = {
  class: "w-full max-w-lg px-3 sm:pl-0 pd:pr-0",
  autocomplete: "off"
}
const _hoisted_6 = { class: "w-80 min-w-fit pr-2 whitespace-nowrap text-right hidden md:inline" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.whoisfreaks.com/",
  rel: "noopener",
  class: "p-3 text-dark"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "hidden xl:inline" }, "DNS lookup"),
  /*#__PURE__*/_createTextVNode(" API ")
], -1)

import { useStore } from 'vuex';
import { PropType, computed } from 'vue';
import { useRouter } from 'vue-router';
import DomainSearch from '@/components/DomainSearch.vue';
import { domainNameToUrlPath } from '@/common/domainName';
import { XMarkIcon } from '@heroicons/vue/24/outline';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  props: {
  domain: {
    type: String,
    default: undefined,
  },
  domainSearchToUrl: {
    type: Function as PropType<(encodedDomain: string) => string>,
    default: undefined,
  },
  searchButtonText: {
    type: String,
    default: undefined,
  },
  autocompleteEnabled: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



const router = useRouter();

const store = useStore();
const toggleBanner = () => store.commit('toggleBanner');
const showBanner = computed(() => store.state.showBanner);

function redirectTo(newDomain: string): void {
  if (props.domainSearchToUrl) {
    router.push(props.domainSearchToUrl(newDomain));
  } else {
    // Vue acts up when setting this as a default prop
    router.push(`/domains/${domainNameToUrlPath(newDomain)}/dns-records/`);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(showBanner))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", {
            class: "justify-self-end p-2 cursor-pointer",
            onClick: toggleBanner
          }, [
            _createVNode(_unref(XMarkIcon), { class: "h-5 w-5" })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "mx-auto mt-4 min-w-fit pl-6 sm:m-0 sm:w-80"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createElementVNode("form", _hoisted_5, [
        _createVNode(DomainSearch, {
          prefill: __props.domain,
          onSubmitted: redirectTo,
          "button-text": __props.searchButtonText,
          "autocomplete-enabled": __props.autocompleteEnabled
        }, null, 8, ["prefill", "button-text", "autocomplete-enabled"])
      ]),
      _createElementVNode("nav", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/learning/",
          class: "p-3 text-dark"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Learning")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/install/",
          class: "p-3 text-dark hidden lg:inline"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Browser extension")
          ]),
          _: 1
        }),
        _hoisted_7
      ])
    ])
  ], 64))
}
}

})